import { ErrorPage } from "Components/ErrorPage/ErrorPage";
import { AiInterviewQuestionsPage } from "Components/Resources/AiInterviewQuestionsPage";
import { AiJobDescriptionPage } from "Components/Resources/AiJobDescriptionPage";
import { ResourcesHome } from "Components/Resources/ResourcesHome";
import { ResourcesWrapper } from "Components/Resources/ResourcesWrapper";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdminRouter } from "./AdminRouter";
import { AuthRouter } from "./AuthRouter";
import { CandidateRouter } from "./CandidateRouter";
import { EmployerRouter } from "./EmployerRouter";
import { EmployerSubDomainRouter } from "./EmployerSubDomainRouter";

export const ShRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* Error 404 page */}
                <Route path="*" element={<ErrorPage />} />

                {/* Account Authentication */}
                <Route path="/" element={<Navigate replace to="/account/" />} />
                <Route path="/account/*" element={<AuthRouter />} />

                {/* Admin routes */}
                <Route path="/admin/*" element={<AdminRouter />} />

                {/* Employer routes*/}
                <Route path="/employer/*" element={<EmployerRouter />} />

                {/* Candidate */}
                <Route path="/candidate/*" element={<CandidateRouter />} />

                {/* Employer Career Pages*/}
                <Route path="/careers/*" element={<EmployerSubDomainRouter />} />

                {/* Job Descriptions */}
                <Route path="/resources" element={<ResourcesWrapper />}>
                    <Route path="/resources" element={<ResourcesHome />}>
                        <Route path="description" element={<AiJobDescriptionPage />} />
                        <Route path="interview-kit" element={<AiInterviewQuestionsPage />} />
                    </Route>
                </Route>

            </Routes>
        </BrowserRouter>
    );
}